<template>
  <div>
    <div class="thisTitle">
      <span class="thisIcon">
        <img src="../../common/images/icon-tixilogo.png" alt=""/>
      </span>
      <span>体系</span>
    </div>
    <div class="TiXiWrap">
      <el-table :data="tableData" class="filterTable" size="small" border style="width: 100%"
                header-row-class-name="table-header" v-loading="loading">
        <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
        <el-table-column prop="masterName" label="项目名称" align="center"></el-table-column>
        <el-table-column :label='item.name' width="220" align="center" v-for="(item,index) in cols" :key="index">
          <template slot-scope="scope">
            <div v-for="(item2,index2) in message" :key="index2" class="isChecked"
                 v-if="item2.masterId == scope.row.masterId && item2.scoreType == item.scoreType">
              <img src="../../common/images/icon-checked.png" alt="">
              已选择
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  //180723韩金辰重写
  export default {
    name: "zSystem",
    data() {
      return {
        cols: [
          {name: '积分', scoreType: 1},
          {name: '星级', scoreType: 2},
          {name: '信用', scoreType: 3},
        ],
        tableData: [],
        loading: false,
        message: [],
      };
    },
    mounted() {
      this.loading = true
      //   搜索体系配置页所有信息
      this.$http({
        method: "get",
        url: "/rest/ScoreSystemSettings/searchMastName"
      }).then(res => {
        this.tableData = res.data;
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
      //上个接口慢，所以用他的then关闭loading
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/search',
        params: {
          startTime: this.$route.query.sTime
        }
      }).then(res => {
        this.message = res.data
      })
    },
  };
</script>
<style scoped lang="scss">
  .thisTitle {
    span:last-child {
      font-size: 15px;
      vertical-align: middle;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .thisIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  .TiXiWrap {
    background-color: white;
    padding: 20px;
    margin: 15px 0;
  }

  .isChecked {
    background-color: #e2e7fb;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }

  .el-table td div {
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/zSystem.vue